import { React, useEffect, useState, useCallback } from "react";
import Background from "../../Background";
import {
    Box,
    GridItem,
    Grid,

} from "@chakra-ui/react";
import Api from "../../..//Helper/ApiHandler";
import ImageViewer from "react-simple-image-viewer";

import { useParams } from "react-router-dom";
import TableLoader from "../../../Components/Common/TableLoader";


const AlbumImages = () => {

    let { id } = useParams();
    const api = new Api();
    let [image, setImages] = useState([])
    const [isFriendModalOpen, setisFriendModalOpen] = useState(false);
    const handleFriendModalClose = async () => {
        setisFriendModalOpen(false);
        // await refetch();
    };
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [ImageLoading, setImageLoading] = useState(false);
    const [fullData, setfullData] = useState([]);
    const [userdata, setUserData] = useState();
    const [userdata1, setUserData1] = useState();
    const [albumName, setAlbumName] = useState();
    const [noImage, setNoImages] = useState(false);
    const [loading, setIsLoading] = useState(true);
    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);
    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };

    setTimeout(() => {
        setIsLoading(false)
    }, 2000)



    const getcardData = async () => {

        let { data } = await api.post(`${"user/image-list"}`, {
            albumId: id,
        });

        if (data[0]) {
            setfullData(data[0].imageData)
            setImages(data[0].images);
            setAlbumName(data[0].albumData[0].name)
        }


    }

    useEffect(() => {
        getcardData()
    }, [])
    return (
        <Background heading={`Album Images${albumName ? "-" + albumName : ""}`} key="user-management" showBack="true">
            <>



                <Box padding={"3"} overflow={"auto"} className='design-scrollbar'>


                    <TableLoader isLoading={loading} version={6} />
                    {!loading ? <Grid templateColumns={"33% 33% 33%"}>
                        {
                            fullData.map((src, index) => {

                                return (

                                    <GridItem padding={1} className="container">

                                        <img loading="lazy" src={src?.mediaUrl} className="image" style={{ height: '215px', width: '445px', borderRadius: "20px", cursor: "pointer" }} effect="blur" onClick={() => {
                                            setImageLoading(true);
                                            setTimeout(() => {
                                                setImageLoading(false);
                                                openImageViewer(index);
                                            }, 50);
                                        }} />
                                        <Box className="middle" position={"absolute"} display={"flex"} alignItems={"center"} onClick={() => {
                                            setImageLoading(true);
                                            setTimeout(() => {
                                                setImageLoading(false);
                                                openImageViewer(index);
                                            }, 50);
                                        }} >

                                        </Box>
                                    </GridItem>
                                )
                            })

                        }
                        {
                            !fullData.length ? !loading && <Box position={"absolute"} top={"50%"} left={"50%"}>No Images</Box> : ""
                        }
                    </Grid> : ""
                    }
                </Box>


                {isViewerOpen && (
                    <Box zIndex={"9999999999"} >

                        <ImageViewer
                            src={image}
                            currentIndex={currentImage}
                            disableScroll={false}
                            closeOnClickOutside={true}
                            onClose={closeImageViewer}
                            backgroundStyle={{
                                backgroundColor: "rgba(0,0,0,0.9)"
                            }}
                        />
                    </Box>
                )}
            </>
        </Background>
    );
};

export default AlbumImages;
